import { defineRecipe } from '@plurall/elo-v3';

export const simpleBarChartRootRecipe = defineRecipe({
  className: 'simple-bar-chart',
  base: {
    width: '100%',
    minWidth: 0,
    paddingTop: 'padding.xsmall',
  },
});

export const simpleBarChartViewportRecipe = defineRecipe({
  className: 'simple-bar-chart__viewport',
  base: {
    width: '100%',
    minWidth: 0,
    overflowX: 'auto',
    overflowY: 'visible',
    scrollbarGutter: { base: 'stable', md: 'auto' },
  },
});

export const simpleBarChartStageRecipe = defineRecipe({
  className: 'simple-bar-chart__stage',
  base: {
    width: '100%',
    minWidth: 'var(--simple-bar-chart-min-width)',
  },
});

export const simpleBarChartTooltipRecipe = defineRecipe({
  className: 'simple-bar-chart__tooltip',
  base: {
    minWidth: '8.75rem',
    paddingBlock: 'padding.3xsmall',
    paddingInline: 'padding.xsmall',
    borderWidth: 'border.width.small',
    borderStyle: 'solid',
    borderColor: 'border.secondary',
    borderRadius: 'border.radius.medium',
    background: 'background.primary',
    boxShadow: 'shadows.sm',
    color: 'text.primary',
  },
});

export const simpleBarChartTooltipTitleRecipe = defineRecipe({
  className: 'simple-bar-chart__tooltip-title',
  base: {
    margin: 0,
    fontSize: 'font.size.small',
    fontWeight: 'bold',
    lineHeight: 'font.line.height.short',
  },
});

export const simpleBarChartTooltipRowRecipe = defineRecipe({
  className: 'simple-bar-chart__tooltip-row',
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 'gap.medium',
    marginTop: 'space.8',
    color: 'text.secondary',
    fontSize: 'font.size.xsmall',
    lineHeight: 'font.line.height.short',
  },
});

export const simpleBarChartTooltipLabelRecipe = defineRecipe({
  className: 'simple-bar-chart__tooltip-label',
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    gap: 'gap.xsmall',
  },
});

export const simpleBarChartTooltipDotRecipe = defineRecipe({
  className: 'simple-bar-chart__tooltip-dot',
  base: {
    width: '0.5rem',
    height: '0.5rem',
    borderRadius: 'border.radius.full',
    flexShrink: 0,
  },
});

export const simpleBarChartTooltipValueRecipe = defineRecipe({
  className: 'simple-bar-chart__tooltip-value',
  base: {
    color: 'text.primary',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
});

export const simpleBarChartLegendRecipe = defineRecipe({
  className: 'simple-bar-chart__legend',
  base: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 'space.8',
    color: 'text.secondary',
    fontSize: 'font.size.small',
    lineHeight: 'font.line.height.short',
  },
});

export const simpleBarChartLegendItemRecipe = defineRecipe({
  className: 'simple-bar-chart__legend-item',
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'gap.xsmall',
  },
});

export const simpleBarChartLegendLineRecipe = defineRecipe({
  className: 'simple-bar-chart__legend-line',
  base: {
    width: '1.75rem',
    borderTopWidth: 'border.width.large',
    borderTopStyle: 'dashed',
    flexShrink: 0,
  },
});
